export default __webpack_public_path__ + "static/media/minizineHero.172a2552.jpg";